export enum COMMON {
    AppInitials = 'SC',
    AppName = 'Stealth Connect',
    ApplicationPlatform = 'Web',
}

export enum PAGE {
    Dashboard = 'Dashboard',
    SiteList = 'SiteList',
    Incidents = 'Incidents',
    IncidentsReports = 'IncidentsReports',
    MapView = 'MapView',
    LiveView = 'LiveView',
    UserManagement = 'UserManagement',
    RoleManagement = 'RoleManagement',
    GroupManagement = 'GroupManagement',
    ManageGroups = 'ManageGroups',
    ContactStealth = 'ContactStealth',
    LogIn = 'LogIn',
    LogOut = 'LogOut',
    ResetPassword = 'ResetPassword',
    ForgotPassword = 'ForgotPassword',
    Playback = 'Playback'
}

export enum COMPONENT {
    Stream = 'Stream',
    webRTCStream = 'webRTC_Stream',
    hlsStream = 'hls_Stream',
    AccountTab = 'AccountTab',
}

export enum OPERATIONS {
    Click = 'Click',
    Loaded = 'Loaded',
    Loading = 'Loading',
    Clicked = 'Clicked',
    Created = 'Created',
    Updated = 'Updated',
    Deleted = 'Deleted',
    Failed = 'Failed',
    Success = 'Success',
    Sending = 'Sending',
    Sent = 'Sent',
    Destroyed = 'Destroyed',
    Received = 'Received',
    LoggedIn = 'LoggedIn',
    LoggedInWithImpersonation = 'LoggedInWithImpersonation',
    LoggedInWithSSO = 'LoggedInWithSSO',
    LoggedOut = 'LoggedOut',
    LoggedOutWithImpersonation = 'LoggedOutWithImpersonation',
    AutoLoggedOut = 'AutoLoggedOut',
    Unimpersonate = 'Unimpersonate',
    Error = 'Error',
}

export enum STREAM_OPERATIONS {
    Attached = 'Attached',
    Detached = 'Detached',
    Parsed = 'Parsed',
    Playing = 'Playing',
    Paused = 'Paused',
    Stopped = 'Stopped',
    Waiting = 'Waiting',
    Initiated = 'Initiated',
    Processed = 'Processed',
    Emptied = 'Emptied',
    Loaded = 'Loaded',
    LoadedMetaData = 'LoadedMetaData',
    CanPlay = 'CanPlay',
    CanPlayThrough = 'CanPlayThrough',
    PlayingStream = 'PlayingStream',
    Ended = 'Ended',
    Seeking = 'Seeking',
    Seeked = 'Seeked',
    NetworkError = 'NetworkError',
    NetworkCountExceeded = 'NetworkCountExceeded',
    MediaError = 'MediaError',
    FatalError = 'FatalError',
    FuctionCalled = 'FuctionCalled',
    HlsNotSupported = 'HlsNotSupported',
    Offline = 'Offline',
    Online = 'Online',
    H265 = 'H265',
    ONVIFSuccess = 'ONVIFSuccess',
    isRTSPUrlCorrect = 'isRTSPUrlCorrect'
}